export default __webpack_public_path__ + "32e4c2c506c25b6e84734c7733dfc60a.svg";